<!-- 页面主体 -->
<template>
    <el-main :class="mainClass">
        <transition name="fade-transform" mode="out-in">
            <!-- <keep-alive :include="cachedViews"> -->
            <router-view :key="key"></router-view>
            <!-- </keep-alive> -->
        </transition>
    </el-main>
</template>

<script>
export default {
    props: {
        noMinWidth: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        // 组件中导出name需要和route中的name相同
        cachedViews() {
            // 缓存页面
            return ["BoxQuery"];
            // return this.$store.state.permission.menuRoutes.map(
            //     (item) => item.name === "BoxQuery",
            // );
        },
        mainClass() {
            const isShanghaiManifest = this.$route.path.includes('sh_manifest') // 上海舱单
            const isVgm = this.$route.path.includes('VGM') // VGM
            const isTruck = this.$route.path.includes('truckSubscribe') // 集卡定位
            const isAssistant = this.$route.path.includes("assistant");
            const isManifestMake =
                this.$route.path.includes("manifestMake") ||
                this.$route.path.includes("roroManifest") ||
                this.$route.path.includes("shManifestRecognize");
            let result = "normal-main";
            if (isShanghaiManifest) {
                result = "shanghai-manifest-main";
            } else if (isVgm) {
                result = "vgm-main";
            } else if (isTruck) {
                result = "truck-main";
            } else if (isManifestMake) {
                result = "manifest-make-main";
            } else if (isAssistant) {
                result = "assistant-main";
            }
            if(this.$store.state.other.recentSubscribeList.length > 0){
                result += ' show-system-dynamic-main';
            }
            if(this.noMinWidth) {
                result += ' no-min-width-main';
            }
            return result;
        },
        key() {
            // 宁波/滚装船舱单：子路由切换时保持布局实例，内部 keep-alive 才能缓存列表
            if (this.$route.path.includes("manifestMake")) {
                return "ManifestMakeLayout";
            }
            if (this.$route.path.includes("roroManifest")) {
                return "RoRoManifestLayout";
            }
            if (this.$route.path.includes("shManifestRecognize")) {
                return "ShManifestRecognizeLayout";
            }
            return this.$route.fullPath;
        },
    },
};
</script>

<style lang="stylus">
.shanghai-manifest-main, .vgm-main, .truck-main {
    height: 100vh;
    overflow: auto;
}
.el-main {
    min-width: 1450px;
    &.assistant-main,
    &.manifest-make-main {
        min-width: unset;
    }
    &.no-min-width-main{
        .el-main{
            min-height: unset !important;
            min-width: unset;
            width: calc(100% - 300px);
        }
    }
}
</style>
